/**
 * RotationControls — sticky bar: manual Preview rotation and (once a preview
 * exists) Apply rotation. Apply is confirmed upstream. Automatic rotation is not
 * a toggle here — it runs as part of the optimizer's scheduled update.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { PlayCircle, RefreshCw } from 'lucide-react';

import { Button } from '@/components/ui';

export interface RotationControlsProps {
  onPreview: () => void;
  previewPending: boolean;
  hasPreview: boolean;
  onApplyClick: () => void;
  applyPending: boolean;
}

const RotationControls: FC<RotationControlsProps> = ({
  onPreview,
  previewPending,
  hasPreview,
  onApplyClick,
  applyPending,
}) => (
  <div className="sticky top-0 z-10 flex flex-wrap items-center gap-2 rounded-md border border-border/60 bg-card/95 px-2 py-1.5 backdrop-blur">
    <Button
      size="sm"
      variant="outline"
      onClick={onPreview}
      loading={previewPending}
      disabled={previewPending}
    >
      <RefreshCw className="mr-1.5 h-3.5 w-3.5" aria-hidden />
      Preview rotation
    </Button>
    {hasPreview ? (
      <Button
        size="sm"
        onClick={onApplyClick}
        loading={applyPending}
        disabled={applyPending}
      >
        <PlayCircle className="mr-1.5 h-3.5 w-3.5" aria-hidden />
        Apply rotation
      </Button>
    ) : null}
    <span className="ml-auto text-[11px] text-muted-foreground">
      Runs automatically with the optimizer&apos;s scheduled update.
    </span>
  </div>
);

export default RotationControls;
